import { OPERATOR_EQUALS, OPERATOR_IN } from '@atlaskit/jql-ast';

export const PACKAGE_NAME = 'jiraFilterRefinement';
export const TEAM_NAME = 'empanada';
export const SOURCE_NAME = 'filterRefinement';

// Field JQL terms
export const ASSIGNEE = 'assignee';
export const ISSUE_KEY = 'issuekey';
export const TEXT_FIELDS = 'textfields';
export const PROJECT_FIELD = 'project';

export const VALID_ASSIGNEE_OPERATORS = new Set([OPERATOR_EQUALS, OPERATOR_IN]);
